module.exports = __webpack_public_path__ + "static/media/no-photo.90413557.png";